module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray-fdd3598685bf70e50364b8be6abc93ef.png";